<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
  >
    <div
      class="relative w-[90%] max-w-lg py-8 px-6 rounded-2xl text-center border border-[#30A733]/40 shadow-[0_0_30px_#30A73380] bg-[#1D1D1D] transition-all duration-300"
    >
      <h2 class="text-[#30A733] text-2xl font-black drop-shadow-md mb-2 flex items-center justify-center gap-2 uppercase tracking-wide">
        ⚠️ {{ title }} ⚠️
      </h2>

      <p class="text-white text-sm md:text-base leading-relaxed mb-6 px-2">
        {{ message }}
      </p>

      <div class="flex justify-center gap-4">
        <button
          @click="onConfirm"
          class="px-6 py-2 bg-[#30A733] text-white font-semibold rounded-xl shadow-md hover:shadow-[0_0_12px_#30A733] hover:brightness-110 transition"
        >
          {{ confirmText }}
        </button>
        <button
          @click="onCancel"
          class="px-6 py-2 bg-transparent text-white font-semibold rounded-xl border border-white/20 hover:bg-white/10 transition"
        >
          {{ cancelText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    message: { type: String, required: true },
    confirmText: { type: String, default: "Yes" },
    cancelText: { type: String, default: "No" },
    isVisible: { type: Boolean, default: false },
  },
  emits: ["confirm", "cancel"],
  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>


<style scoped>

button {
  transition: background-color 0.3s ease;
}
</style>
